<template>
  <div class="main_container main_container_fixed">
    <template v-if="getMotorPaymentStep === 1">
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6">
          <img src="@/assets/images/Group-11560.svg" loading="lazy" width="126" alt="" class="image-4" />
          <h1 class="heading-3" v-html="$t(helpTexts[getMotorPaymentStep])"></h1>
        </div>
      </div>
      <div class="sub_container w-form">
        <driver-details v-if="getMotorPaymentStep === 1 && data.CS_POLICY_HOLDER" :data="data" @next=updateStep />
      </div>
      <div class="sub_container footer w-row">
        <div class="column_footer_b w-clearfix w-col w-col-6">
          <img src="@/assets/images/Group-10068.svg" loading="lazy" alt="" class="image-5" />
          <p class="bold_label">{{ $t('FIELDS_REQUIRED_EXCEPT') }}</p>
        </div>
        <div class="column_footer_b w-clearfix w-col w-col-6">
          <img src="@/assets/images/Group-11600.svg" loading="lazy" alt="" class="image-6" />
          <p class="bold_label">
            {{ $t('FIELDS_CHECKED_TOM_CALCULATED_COST') }}
          </p>
        </div>
      </div>
    </template>
    <gdpr-details v-if="getMotorPaymentStep === 2 && data.CS_POLICY_HOLDER" :data="data" @payment="JccPayment" />

    <!-- Hidden form to submit to JCC  -->
    <form v-if="data.CS_POLICY" v-show="false" method="post" ref="paymentForm" :action="jcc_link">
      <input type="hidden" name="Version" :value="jcc_data.Version" /><br />
      <input type="hidden" name="MerID" :value="jcc_data.MerID" /><br />
      <input type="hidden" name="AcqID" :value="jcc_data.AcqID" /><br />
      <input type="hidden" name="MerRespURL" :value="jcc_data.MerRespURL" /><br />
      <input type="hidden" name="PurchaseAmt" :value="PurchaseAmt" /><br />
      <input type="hidden" name="PurchaseCurrency" :value="jcc_data.PurchaseCurrency" /><br />
      <input type="hidden" name="PurchaseCurrencyExponent" :value="jcc_data.PurchaseCurrencyExponent" /><br />
      <input type="hidden" name="OrderID" :value="data.CS_POLICY.CONTRACT_NO" /><br />
      <input type="hidden" name="CaptureFlag" :value="jcc_data.CaptureFlag" /><br />
      <input type="hidden" name="Signature" :value="Signature" /><br />
      <input type="hidden" name="SignatureMethod" :value="jcc_data.SignatureMethod" /><br />
    </form>
  </div>
</template>

<script>
import DriverDetails from '@/views/Motor/Payment/PaymentComponents/DriverDetails.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import { JCC_LINK, JCC_REDIRECT_LINK, JCC_PASSWORD } from '@/shared/config';
import sha1 from 'crypto-js/sha1';
import Base64 from 'crypto-js/enc-base64';
import padStart from 'lodash/padStart';
import padEnd from 'lodash/padEnd';

export default {
  data() {
    return {
      helpTexts: {
        1: 'CONTACT_ADDRESS'
      },
      jcc_link: JCC_LINK || '',
      jcc_data: {
        Version: '1.0.0',
        MerID: '0099691016',
        AcqID: '402971',
        MerRespURL: JCC_REDIRECT_LINK || '',
        // PurchaseAmt: '000000002050',
        PurchaseCurrency: 978,
        PurchaseCurrencyExponent: 2,
        // OrderID: 'TestOrder758',
        CaptureFlag: 'A',
        SignatureMethod: 'SHA1'
      }
    };
  },
  components: {
    DriverDetails,
    GdprDetails: () => import('@/views/Motor/Payment/PaymentComponents/GdprDetails.vue')
  },
  computed: {
    ...mapGetters('motor', ['getMotorPaymentStep']),
    ...mapState({
      data: (state) => state.motor.motor
    }),
    PurchaseAmt() {
      let amount = this.data.CS_POLICY.AMOUNT || 0;
      amount = String(amount);
      if (amount.includes('.')) {
        amount = amount.replace('.', '');
      } else {
        amount = padEnd(amount, amount.length + 2, '0');
      }
      amount = padStart(amount, 12, '0');
      return amount;
    },
    Signature() {
      return this.SignatureEncryption();
    }
  },
  async created() {
    if (!this.data.CS_POLICY || this.data.CT_OFFERS.length === 0) {
      this.$router.push({ path: '/motor' });
    }
  },
  methods: {
    ...mapActions('motor', ['setMotorPaymentStepAction', 'motorQuotationAction', 'motorUpdateDataAction']),
    async updateStep() {
      this.motorUpdateDataAction(this.data);
      await this.setMotorPaymentStepAction(this.getMotorPaymentStep + 1);
      Vue.nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    SignatureEncryption() {
      const hashDigest = sha1(`${JCC_PASSWORD}${this.jcc_data.MerID}${this.jcc_data.AcqID}${this.data.CS_POLICY.CONTRACT_NO}${this.PurchaseAmt}${this.jcc_data.PurchaseCurrency}`);
      // console.log(hashDigest.toString());
      // console.log(hashDigest.toString());
      const hmacDigest = Base64.stringify(hashDigest, 'H*');
      // console.log(hmacDigest);
      return hmacDigest;
    },
    async JccPayment() {
      const {
        CS_VEHICLE, CS_DRIVERS, CS_POLICY_HOLDER, CS_PROMO_CODE, CS_POLICY, CT_COVERS
      } = this.data;
      await this.motorQuotationAction({
        CS_VEHICLE,
        CS_DRIVERS,
        CS_POLICY_HOLDER,
        CS_PROMO_CODE,
        CS_POLICY,
        CT_COVERS
      });
      this.$refs.paymentForm.submit();
    }
  }
};
</script>
